import TodoMenu from '../../body/todo/menu/TodoMenu';

const TodoMenuSection = () => {
  return <TodoMenu></TodoMenu>;
};

export default TodoMenuSection;
